import React, { useEffect, useState } from 'react';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  
  const [submitted, setSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState('form');
  
  useEffect(() => {
    // Animation for elements when page loads
    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show');
        }
      });
    }, { threshold: 0.1 });
    
    animatedElements.forEach(el => observer.observe(el));
    
    return () => {
      animatedElements.forEach(el => observer.unobserve(el));
    };
  }, []);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic would go here
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
      });
    }, 3000);
  };
  
  return (
    <div className="contact-page-container">
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="contact-hero-content animate-fade-in">
          <h1 className="font-playfair animate-slide-up">İletişim</h1>
          <p className="hero-subtitle animation-delay-300 animate-slide-up">
            Bizimle iletişime geçin, kahve sohbetine bekliyoruz.
            <span className="animate-coffee ml-2">☕</span>
          </p>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="contact-main-container">
        {/* Contact Card */}
        <div className="contact-card animate-on-scroll">
          <div className="contact-card-tabs">
            <button 
              className={`contact-tab ${activeTab === 'form' ? 'active' : ''}`}
              onClick={() => setActiveTab('form')}
            >
              <i className="fas fa-envelope mr-2"></i>
              Form ile İletin
            </button>
            <button 
              className={`contact-tab ${activeTab === 'info' ? 'active' : ''}`}
              onClick={() => setActiveTab('info')}
            >
              <i className="fas fa-info-circle mr-2"></i>
              İletişim Bilgileri
            </button>
          </div>
          
          <div className="contact-card-content">
            {activeTab === 'form' && (
              <div className="contact-form-container animate-fade-in">
                {submitted ? (
                  <div className="success-message">
                    <div className="success-icon">✓</div>
                    <h3>Teşekkürler!</h3>
                    <p>Mesajınızı aldık. En kısa sürede size dönüş yapacağız.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="contact-form">
                    <div className="form-group">
                      <label htmlFor="name">Adınız</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="form-input"
                        placeholder="Adınızı giriniz"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="email">E-posta</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="form-input"
                        placeholder="E-posta adresinizi giriniz"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="subject">Konu</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                        className="form-input"
                        placeholder="Konu başlığı"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="message">Mesajınız</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        className="form-input"
                        rows="5"
                        placeholder="Bizimle paylaşmak istediğiniz düşünceleriniz..."
                      ></textarea>
                    </div>
                    
                    <button type="submit" className="submit-button">
                      <span>Gönder</span>
                      <i className="fas fa-paper-plane ml-2"></i>
                    </button>
                  </form>
                )}
              </div>
            )}
            
            {activeTab === 'info' && (
              <div className="contact-info-container animate-fade-in">
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className="contact-info-content">
                    <h3>Adresimiz</h3>
                    <p>Bağdat Caddesi No:123, Kadıköy</p>
                    <p>İstanbul, Türkiye</p>
                  </div>
                </div>
                
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-phone-alt"></i>
                  </div>
                  <div className="contact-info-content">
                    <h3>Telefon</h3>
                    <p>+90 (212) 123 45 67</p>
                    <p>+90 (532) 987 65 43</p>
                  </div>
                </div>
                
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="contact-info-content">
                    <h3>E-posta</h3>
                    <p>info@kahvekafe.com</p>
                    <p>rezervasyon@kahvekafe.com</p>
                  </div>
                </div>
                
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <div className="contact-info-content">
                    <h3>Çalışma Saatleri</h3>
                    <p>Pazartesi - Cuma: 08:00 - 22:00</p>
                    <p>Cumartesi - Pazar: 09:00 - 23:00</p>
                  </div>
                </div>
                
                <div className="social-media-links">
                  <a href="#" className="social-link"><i className="fab fa-facebook-f"></i></a>
                  <a href="#" className="social-link"><i className="fab fa-instagram"></i></a>
                  <a href="#" className="social-link"><i className="fab fa-twitter"></i></a>
                  <a href="#" className="social-link"><i className="fab fa-youtube"></i></a>
                </div>
              </div>
            )}
          </div>
        </div>
        
        {/* Map Section */}
        <div className="map-container animate-on-scroll">
          <div className="map-overlay">
            <div className="map-card">
              <h3 className="font-playfair">Bizi Ziyaret Edin</h3>
              <p>Sıcak bir kahve eşliğinde sohbet etmek için sizi kafemize bekliyoruz!</p>
              <a href="https://maps.google.com" target="_blank" rel="noreferrer" className="map-button">
                Yol Tarifi Al
                <i className="fas fa-directions ml-2"></i>
              </a>
            </div>
          </div>
          <div className="map-frame">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24087.56943096569!2d29.021015!3d41.011583!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac790b17ba89d%3A0xd2d24ea0437a7ee2!2zS2FkxLFrw7Z5LCDEsHN0YW5idWw!5e0!3m2!1str!2str!4v1625000000000!5m2!1str!2str" 
              width="100%" 
              height="100%" 
              style={{border:0}} 
              allowFullScreen="" 
              loading="lazy"
              title="Kafe Konumu"
            ></iframe>
          </div>
        </div>
      </div>
      
      {/* CTA Section */}
      <div className="cta-section mt-16 animate-on-scroll">
        <div className="cta-content">
          <h2 className="font-playfair">Kahve Keyfinizi Paylaşın</h2>
          <p>Sosyal medya hesaplarımızı takip edin, özel tekliflerden ve etkinliklerden haberdar olun.</p>
          <div className="cta-social-links">
            <a href="#" className="cta-social-button">
              <i className="fab fa-instagram"></i>
              <span>Instagram</span>
            </a>
            <a href="#" className="cta-social-button">
              <i className="fab fa-facebook-f"></i>
              <span>Facebook</span>
            </a>
            <a href="#" className="cta-social-button">
              <i className="fab fa-twitter"></i>
              <span>Twitter</span>
            </a>
          </div>
        </div>
      </div>
      
      {/* Newsletter Section */}
      <div className="newsletter-section animate-on-scroll">
        <div className="newsletter-content">
          <h3 className="font-playfair">Bültenimize Abone Olun</h3>
          <p>Yeni lezzetler, özel indirimler ve etkinlikler hakkında bilgi alın.</p>
          <div className="newsletter-form">
            <input type="email" placeholder="E-posta adresiniz" className="newsletter-input" />
            <button className="newsletter-button">
              Abone Ol
              <i className="fas fa-arrow-right ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
